import React, { Component } from 'react';
import { ButtonReg } from 'atoms/Buttons';
import Breadcrumb from 'molecules/Breadcrumb';
import CompanyFilter from 'molecules/CompanyFilter';
import DataTables from 'organisms/DataTable';
import { actionFormatter, statusDotFormatter, chipFormatter } from 'molecules/TableFormatters';
import { GET_CONTRACTORS } from 'fixtures/api';
import { NewContractor } from 'fixtures/TemplateData';
import { dashboardCreate, dashboardDelete, dashboardUpdate } from 'fixtures/permissions';
import { permissionCheck } from 'helpers/permissionCheckHelper';
import { postNewData, putData, deleteData } from 'services/cmsService';
import { getAllContractorsData, editContractorData, addContractorData } from 'Redux/actions/ContractorListActions';
import { getAllContractorCategoriesData } from 'Redux/actions/ContractorCategoryListActions';
import { toggleIsLoading } from 'Redux/actions/ViewStateActions';
import { setLocalSettingsTableData } from 'Redux/actions/SettingsTableActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withTheme } from 'styled-components';
import { PageWrapper, TableWrapper } from './styles';
import lo from 'lodash';

import {
  TxtSuccessSubmitContractor,
  TxtConfirmDeleteContractor,
  TxtSuccessDeleteContractor,
  TxtFailedDeleteContractor,
  TxtFailedSubmitData
} from 'fixtures/texts';
import ModalPage from 'components/templates/ModalPage/index';
import NewContractorModal from 'components/organisms/NewContractorModal';

export class ContractorList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isShowModal: false,
      isSubmitDisabled: false,
      isError: { status: false, msg: '' },
      contractorData: {},
      navList: [
        'Contractor',
        'Contractor List'
      ],
      allowCreate: false,
      allowDelete: false,
      allowUpdate: false,
    }
  }

  componentDidMount() {
    this.props.toggleIsLoading(true)
    this.props.getAllContractorsData()
    this.props.getAllContractorCategoriesData()
    this.checkPermission()
  }

  componentDidUpdate(prevProps) {
    const { contractorsList, viewState: { isLoading }, userLogin } = this.props
    if (prevProps.contractorsList !== contractorsList && isLoading) {
      this.props.toggleIsLoading(false)
    }
    if (prevProps.userLogin !== userLogin) {
      this.checkPermission()
    }
  }

  // method for checking access permission
  checkPermission() {
    const { userLogin } = this.props
    if (userLogin && userLogin.userDetail) {
      const { userDetail: { permissions } } = userLogin
      this.setState({
        allowCreate: permissionCheck(permissions, dashboardCreate),
        allowDelete: permissionCheck(permissions, dashboardDelete),
        allowUpdate: permissionCheck(permissions, dashboardUpdate),
      })
    }
  }

  // method for deleting contractor
  async onDeleteContractor(contractor) {
    const isOk = window.confirm(TxtConfirmDeleteContractor)
    if (isOk) {
      const uri = `${GET_CONTRACTORS}/${contractor.id}`
      try {
        const res = await deleteData(uri)
        if (res.status !== 500) {
          alert(TxtSuccessDeleteContractor)
          this.props.getAllContractorsData()
        } else {
          throw res
        }
      } catch (error) {
        alert(TxtFailedDeleteContractor)
      }
    }
  }

  // method for adding new contractor
  addNewContractor() {
    this.switchModal(lo.cloneDeep(NewContractor))
  }

  // method for submitting contractor
  async onSubmitContractor() {
    const { contractorData } = this.state
    const { isNew, contractorCategory, ...rest } = contractorData
    const sendObj = lo.cloneDeep({
      ...rest,
      contractorCategoryId: contractorCategory ? contractorCategory.id : null
    })
    const uri = sendObj.hasOwnProperty('createdAt') ?
      `${GET_CONTRACTORS}/${sendObj.id}` :
      GET_CONTRACTORS

    try {
      const putObj = {
        name: contractorData.name,
        code: contractorData.code,
        contractorCategoryId: contractorData.contractorCategory.id,
        isActive: contractorData.isActive
      }
      const res = sendObj.hasOwnProperty('createdAt') ?
        await putData(uri, putObj) :
        await postNewData(uri, sendObj)
      if (res.status === 201 || res.status === 204) {
        alert(TxtSuccessSubmitContractor)
        this.setState({ isSubmitDisabled: false })
        this.props.getAllContractorsData()
        this.switchModal(lo.cloneDeep(NewContractor))
      } else {
        throw res
      }
    } catch (err) {
      alert(TxtFailedSubmitData)
      this.setState({ isSubmitDisabled: false })
    }
  }

  switchModal(contractorData) {
    const { isShowModal } = this.state
    this.setState({ contractorData }, () => {
      this.setState({ isShowModal: !isShowModal })
    })
  }

  // change contractor data state
  onChangeContractorData(val, field) {
    let contractor = Object.assign(this.state.contractorData)
    contractor[field] = val
    this.setState({ contractorData: contractor })
  }

  onSizePerPageChange = (size) => {
    const { setLocalSettingsTableData, settingsTable } = this.props
    const settings = lo.cloneDeep(settingsTable)
    settings.sizePerPage[this.state.navList[0]] = size
    setLocalSettingsTableData(settings)
  }

  render() {
    const { isShowModal, isSubmitDisabled, isError, contractorData, navList } = this.state
    const { contractorsList, theme, settingsTable, viewState: { isLoading, isMobileView } } = this.props

    const sizePerPage = settingsTable.sizePerPage[navList[0]]

    const config = [
      {
        dataField: 'code',
        text: 'Contractor Code',
        headerAttrs: { width: isMobileView ? 150 : 200 },
        sort: true
      },
      {
        dataField: 'name',
        text: 'Contractor Name',
        headerAttrs: { width: isMobileView ? 150 : 200 },
        sort: true
      },
      {
        dataField: 'contractorCategory',
        text: 'Category',
        headerAttrs: { width: isMobileView ? 150 : 200 },
        sort: true,
        formatter: chipFormatter,
        formatExtraData: {
          field: 'contractorCategory',
          val: row => row.contractorCategory ? row.contractorCategory.name : null,
          color: theme.mocaOrange,
          theme
        }
      },
      {
        dataField: 'isActive',
        text: 'Active',
        formatter: statusDotFormatter,
        formatExtraData: {
          field: 'isActive',
          theme
        },
        headerAttrs: { width: isMobileView ? 150 : 200 },
        editable: false,
        isDummyField: true
      },
      {
        dataField: 'action',
        text: 'Action',
        sort: false,
        headerAttrs: { width: isMobileView ? 100 : 150 },
        formatter: actionFormatter,
        formatExtraData: {
          allowEdit: this.state.allowUpdate,
          allowDel: this.state.allowDelete,
          edit: (row) => this.switchModal.bind(this, row),
          del: (row) => this.onDeleteContractor.bind(this, row),
        },
        headerAlign: 'center',
        align: 'center',
        isDummyField: true
      }
    ]

    return (
      <PageWrapper isMobile={isMobileView}>
        <Breadcrumb navList={navList}>
          <CompanyFilter />
        </Breadcrumb>
        <ModalPage
          isOpen={isShowModal}
          fnSwitch={this.switchModal.bind(this)}
          contentChild={
            <NewContractorModal
              fnChange={this.onChangeContractorData.bind(this)}
              fnSubmit={this.onSubmitContractor.bind(this)}
              fnSwitch={this.switchModal.bind(this)}
              contractorData={contractorData}
              isDisabled={isSubmitDisabled}
              isError={isError}
              {...this.props}
            />
          }
        />
        {!isLoading &&
          <TableWrapper>
            <DataTables
              leftSlot={
                this.state.allowCreate &&
                <ButtonReg
                  btnTxt={'Add'}
                  disabled={false}
                  onClick={() => this.addNewContractor()}
                  width={'78px'}
                />
              }
              isMobile={isMobileView}
              dataList={contractorsList}
              columnConfig={config}
              sizePerPage={sizePerPage}
              onSizePerPageChange={this.onSizePerPageChange}
            />
          </TableWrapper>
        }
      </PageWrapper>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    contractorsList: state.contractorsList,
    contractorCategoriesList: state.contractorCategoriesList,
    userLogin: state.userLogin,
    viewState: state.viewState,
    settingsTable: state.settingsTable
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getAllContractorsData,
      editContractorData,
      addContractorData,
      getAllContractorCategoriesData,
      toggleIsLoading,
      setLocalSettingsTableData,
    },
    dispatch
  )

export default withTheme(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContractorList)
);
